import { COLORS_OPTIONS } from "constants/options";
import { Option } from "ui";

import { AttributeValue } from "../categories.types";

export const getColorsOptionsWithDisabling = (
  selectableColorValues: AttributeValue[]
): Option[] => {
  const optionsWithServerDisabling = COLORS_OPTIONS.map((option) => {
    const optionInSelectableList = selectableColorValues.find(
      (selectedValue) => selectedValue.value === option.value
    );

    return {
      ...option,
      disabled: optionInSelectableList?.isValidToDelete === false
    };
  });

  const isNoSizesSelected = selectableColorValues.some(
    (value) => value.value === "No colors" && !value.delete
  );

  const isSomeSizesSelected = selectableColorValues.some(
    (value) => value.value !== "No colors" && !value.delete
  );

  if (isNoSizesSelected) {
    return optionsWithServerDisabling.map((colorOption) => ({
      ...colorOption,
      disabled: colorOption.disabled || colorOption.value !== "No colors"
    }));
  }

  if (isSomeSizesSelected) {
    return optionsWithServerDisabling.map((colorOption) => ({
      ...colorOption,
      disabled: colorOption.disabled || colorOption.value === "No colors"
    }));
  }

  return COLORS_OPTIONS;
};
